export default "__VITE_ASSET__DvQMV1CR__"